var App = App || {};

App.Animation = (function ($) {
    "use strict";

    function init() {
        $("#whats-new").ZagScrollAnimate({
            offset: 100,
            targets: [
                { selector: ".btn-whats-new", type: "animate__heartBeat2", stagger: 0 }
            ]
        });

        $(".homepage-banner").ZagScrollAnimate({
            offset: 20,
            targets: [
                { selector: ".homepage-banner-outer + .container", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".carousel-banner").ZagScrollAnimate({
            offset: 20,
            targets: [
                { selector: ".carousel-banner-outer + .container", type: "animate__fadeInUp", stagger: 0 }
            ]
        });

        $(".block.block-promo-cards").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".promo-card", type: "animate__fadeInUp", stagger: 100 }
            ]
        });

        $(".block.block-ctas").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: "li", type: "animate__fadeInUp", stagger: 100 }
            ]
        });

        $(".block.block-resources-band").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".img-wrapper.desktop img", type: "animate__fadeInRight", stagger: 0 }
            ]
        });

        $(".block.block-feature-cards").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".feature-card", type: "animate__fadeInUp", stagger: 100 }
            ]
        });

        $(".block.block-cross-promo").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".cross-promo-inner > img", type: "animate__fadeInLeft", stagger: 0 }
            ]
        });

        $(".block.block-subpage-list").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".subpage-card", type: "animate__fadeInUp", stagger: 100 }
            ]
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Animation.init();
});